/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { AppConstants } from 'src/app/shared/constants/constants';
import { CommonModalService } from '../../events/services/common-modal.service';
import { DataServiceServiceProfile } from '../services/profile-data-service.service';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';
import { SharedModule } from 'src/app/shared/shared.module';


@Component({
  selector: 'app-invite-member-form',
  templateUrl: './invite-member-form.component.html',
  styleUrls: ['./invite-member-form.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
})
export class InviteMemberFormComponent implements OnInit {
  public fb = inject(UntypedFormBuilder);
  private readonly commonModalService = inject(CommonModalService);
  private readonly dataServiceProfile = inject(DataServiceServiceProfile);
  private readonly cdref = inject(ChangeDetectorRef);
  private readonly _loadingSpinnerService = inject(LoadingSpinnerService);
  private readonly _destroyRef = inject(DestroyRef);

  headerTitle: string = 'BP_PM_ADD_MEMBER_TITLE'
  closeButtonTitle: string = AppConstants.COMMON_BUTTON_LABELS.CLOSE
  saveButtonTitle: string = 'Add'
  isCloseModal: boolean = false
  showModal: boolean = true
  formSubmitted: boolean = false
  type: string = 'small-popup'
  isHeaderVisible: boolean = true
  isFooterVisible: boolean = true
  groupName: any
  errorAddMember: boolean = false;
  errorMessage: string = ''

  @ViewChild('showModalContent') showModalContent: TemplateRef<any> | any

  @Output() closeModalEmitter = new EventEmitter<boolean>();
  @Output() getMemberListData = new EventEmitter<boolean>();

  addMemberForm = this.fb.group({
    userId: ['', [Validators.required,
    Validators.minLength(3),
    Validators.maxLength(20),
    Validators.pattern('^[a-zA-Z0-9]*$')]
    ]
  })

  ngOnInit(): void {
    this.commonModalService._modalHeaderIsCloseBtnVisible.next(true)
    this.commonModalService._modalHeaderIsSaveBtnVisible.next(true)
    this.commonModalService._modalHeaderTitle.next(this.headerTitle)
    this.addMemberForm.get('userId')?.valueChanges
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(_value => {
        this.validateInput();
      });

  }


  closeModal() {
    this.isCloseModal = true
    this.showModal = false;
    this.closeModalEmitter.emit(true);
    this.cdref.markForCheck();
  }

  public onSubmit(): void {
    this.formSubmitted = true
    if (this.addMemberForm.valid) {
      this._loadingSpinnerService.show()
      this.groupName = localStorage.getItem("aliasGroupName")
      const data = {
        "shortId": this.addMemberForm.value.userId.toUpperCase(),
        "profileId": this.groupName
      }
      this.dataServiceProfile.postMember(data).subscribe({
        next: (res: any) => {
          const data = res.body
          if (data) {
            this.closeModal()
            this.getMemberListData.emit(true);
            this.cdref.markForCheck();
          }
        }, error: (error: any) => {
          this._loadingSpinnerService.hide()
          if (error["error"]["error-code"] == '1719') {
            this.errorAddMember = true
            this.addMemberForm.controls['userId'].setErrors({ 'incorrect': true });
            this.errorMessage = error["error"]["error-message"]
          }
          this.cdref.markForCheck();
        }
      })
    }
  }

  validateInput(): void {
    this.errorAddMember = false;
    this.formSubmitted = false;
    this.cdref.markForCheck();
  }
}
